import script from "./LiveFeed.vue?vue&type=script&lang=ts&setup=true"
export * from "./LiveFeed.vue?vue&type=script&lang=ts&setup=true"

import "./LiveFeed.vue?vue&type=style&index=0&id=952267a8&scoped=true&lang=less"
import "./LiveFeed.vue?vue&type=style&index=1&id=952267a8&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-952267a8"]])

export default __exports__